import React from "react";
import { INavBarIconInterface } from "../Helpers/types";

export default function IconCalendar(props: INavBarIconInterface) {
  return (
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.1 23.4H2.90005V9.1H21.1V23.4ZM17.2 0V2.6H6.80005V0H4.20005V2.6H2.90005C1.45705 2.6 0.300049 3.757 0.300049 5.2V23.4C0.300049 24.0896 0.573977 24.7509 1.06157 25.2385C1.54917 25.7261 2.21049 26 2.90005 26H21.1C21.7896 26 22.4509 25.7261 22.9385 25.2385C23.4261 24.7509 23.7001 24.0896 23.7001 23.4V5.2C23.7001 3.757 22.5301 2.6 21.1 2.6H19.8V0H17.2ZM18.5 14.3H12V20.8H18.5V14.3Z"
        className={props.selected ? "fill-brij-Mud" : "fill-brij-Default"}
      ></path>
    </svg>
  );
}
